(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('CartLabelService', CartLabelService);

    CartLabelService.$inject = ['$log', '$translate'];

    function CartLabelService($log, $translate) {

        var service = {
            getCartLabelForItem: getLabelForItem
        };

        function getLabelForItem(item, lang) {
            //$log.debug('CartController | creating label for ', item);
            if (item.type == 'Fee') {
                return '';
            } else if (item.type == 'Area') {
                if (item.areaType == 'Open_Space') {
                    var powerUnit = '';
                    if (item.cartPositionPowerUnit == 'KILOWATT') {
                        powerUnit = 'kW';
                    } else if (item.cartPositionPowerUnit == 'TONS') {
                        powerUnit = 't';
                    }

                    var areaLabel = ' - ' + item.cartPositionBookingOptionTitle[lang] + ' - ' + item.fields.powerAmount + ' ' + powerUnit;
                    if (item.fields.additionalSquareMeters) {
                        areaLabel += " + " + item.fields.additionalSquareMeters + ' ' + $translate.instant('cart.squaremeters');
                        areaLabel += ' ' + $translate.instant('cart.disposalIncluded');
                    }
                    return areaLabel;
                } else if (item.areaType == 'Pavillion') {
                    var areaLabel = ' - ' + item.squaremeters + ' ' + $translate.instant('cart.squaremeters');
                    if (item.cartPositionBookingOptionTitle) {
                        areaLabel += ' - ' + item.cartPositionBookingOptionTitle[lang];
                    }
                    areaLabel += ' ' + $translate.instant('cart.disposalIncluded');

                    $log.debug('CartLabelService | Pavillion area label', areaLabel);

                    return areaLabel;
                } else if (item.areaType == 'Outdoor_area' || item.areaType == 'Outdoor_area_static') {
                    var areaLabel = ' - ' + item.squaremeters + ' ' + $translate.instant('cart.squaremeters');
                    areaLabel += ' ' + $translate.instant('cart.disposalIncluded');
                    return areaLabel;
                }
            } else if (item.type == 'Part') {
                var partLabel =  item.cartPositionColorLabel[lang] + ' - ' + item.cartPositionAreaLabel[lang];
                return partLabel;
            }
        }

        return service;


    }
})();
